import { render, staticRenderFns } from "./OnboardingSummaryCard.vue?vue&type=template&id=5b4c6f76&"
import script from "./OnboardingSummaryCard.vue?vue&type=script&lang=js&"
export * from "./OnboardingSummaryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports